import _ from 'lodash';
import React from 'react';
import { DisciplineFilter, ProjectRoleFilter } from '~/components';
import { useFeatures } from '~/hooks';
import FiltersGroup from './FiltersGroup';

export default function ProjectRoleFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Project Role Filters"
      filters={[
        filters.projectRoles,
        filters.projectTaskRecordStatusId,
        filters.projectTaskStatuses,
        filters.projectTaskTags,
      ]}>
      {_.has(filters, 'projectRoles') && filters.projects?.length === 1 && (
        <ProjectRoleFilter
          project={filters.projects[0]}
          value={filters.projectRoles}
          onChange={({ target: { value } }) => onChange({ projectRoles: value })}
        />
      )}

      {features.disciplines && _.has(filters, 'projectRoleDisciplines') && (
        <DisciplineFilter
          value={filters.projectRoleDisciplines}
          placeholder="Project Role Discipline"
          onChange={({ target: { value } }) => onChange({ projectRoleDisciplines: value })}
        />
      )}
    </FiltersGroup>
  );
}
